<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ __('Bejelentkezés') }}</h1>
        <p class="mb-16 text-center"><strong v-html="__('Rendelési rendszerünk megújult, használatához új regisztrációra van szükség (név, e-mail cím, telefonszám), ami kb fél percet vesz igénybe.<br />A desktop verzió mellett már mobilapplikációval is használható.')"></strong></p>
        <div class="flex justify-center gap-4 mb-16">
            <a href="https://apps.apple.com/hu/app/pipacs-rendel%C3%A9s/id6744015744" target="_blank"><img class="h-12" src="/img/app-store.png" /></a>
            <a href="https://play.google.com/store/apps/details?id=hu.pipacspekseg.rendeles&pli=1" target="_blank"><img class="h-12" src="/img/play-store.png" /></a>
        </div>

        <form class="flex flex-col items-center md:w-1/2 mx-auto"
              v-on:keyup.enter="submit"
        >
            <c-control-text class="mb-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="email" required type="email"
                            v-bind:invalid="!!requestStore.errors?.email"
                            v-bind:label="__('E-mail cím')"
                            v-bind:placeholder="__('placeholders.email')"
                            v-model="email"
            />

            <div class="flex items-end w-full">
                <c-control-text class="mb-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="password" placeholder="**********" required type="password"
                                v-bind:invalid="!!requestStore.errors?.password"
                                v-bind:label="__('Jelszó')"
                                v-if="!showPassword"
                                v-model="password"
                />
                <c-control-text class="mb-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="password" placeholder="**********" required type="text"
                                v-bind:invalid="!!requestStore.errors?.password"
                                v-bind:label="__('Jelszó')"
                                v-if="showPassword"
                                v-model="password"
                />
                <a class="bg-white block border-b border-slate-300 cursor-pointer mb-8 shrink-0"
                   v-on:click="showPassword = !showPassword"
                >
                    <span class="border-b border-highlight flex h-10 items-center p-2">
                        <c-icon class="h-6 stroke-slate-800 w-6" icon="eye"
                                v-if="!showPassword"
                        />
                        <c-icon class="h-6 stroke-slate-800 w-6" icon="eye-off"
                                v-if="showPassword"
                        />
                    </span>
                </a>
            </div>

            <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight mb-4 normal-case px-4 py-2 rounded-none text-center !text-lg text-white transition-colors w-48"
                      v-on:click="submit"
            >
                {{ __('Bejelentkezés') }}
            </c-button>

            <router-link class="block underline mb-2 text-slate-800 text-sm"
                         v-bind:to="{ name: 'forgot-password' }"
            >
                {{ __('Elfelejtett jelszó?') }}
            </router-link>

            <span class="flex text-sm">
                {{ __('Nincs még fiókod?') }}
                <router-link class="block underline ml-1 text-highlight"
                             v-bind:to="{ name : 'register' }">
                    {{ __('Regisztrálj itt') }}
                </router-link>
            </span>
        </form>
    </div>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import {
        CButton,
        CControlText,
        CIcon,
    } from '@teamfurther/cinderblock';
    import { useRequestStore }  from '../../stores/request';
    import { useSessionStore }  from '../../stores/session';

    const email = ref('');
    const password = ref('');
    const requestStore = useRequestStore();
    const route = useRoute();
    const sessionStore = useSessionStore();
    const showPassword = ref(false);

    async function submit() {
        await sessionStore.logUserIn(email.value, password.value);
    }

    onMounted(async () => {
        if (route.query.token) {
            await sessionStore.logUserInByToken(route.query.token);

            return;
        }

        if (sessionStore.user) {
            requestStore.redirect({ name: 'errors.403' });
        }
    });
</script>
